import React, {useState, useContext, useEffect} from "react";
import {azureTokenContext, userInfoContext} from "../../App";

import * as ApiCalls from "./ApiCalls";

import "../../style/contracts.css";

export default function Contracts() {
    const azureToken = useContext(azureTokenContext);
    const [userInfo] = useContext(userInfoContext);
    const [loadingStatus, setLoadingStatus] = useState("loading");
    const [contracts, setContracts] = useState([]);

    useEffect(() => {
        if (userInfo.Id) {
            ApiCalls.getContracts(userInfo, azureToken)
                .then((response) => {
                    setContracts(response);
                    setLoadingStatus("done");
                })
                .catch((error) => {
                    console.log(error);
                    setLoadingStatus("error");
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo.Id]);

    return (
        <>
            <>
                {loadingStatus === "done" && contracts && contracts.length > 0 && (
                    <>
                        <div className="contract-table-container">
                            <table className="contract-table">
                                <thead>
                                <tr>
                                    <th className="table-head-title">Dine publikasjoner</th>
                                    <th className="table-head-contract-type">Utbetaling til</th>
                                </tr>
                                </thead>
                                <tbody>
                                {contracts.map((row: any, index) => (
                                    <tr key={index}>
                                        <td className="table-body-title">{row.DocumentTitle}</td>
                                        <td className="table-body-contract-type">
                                            {row.CompanyContract && row.CompanyContract === true
                                                ? "Firma: Ditt firma sender faktura"
                                                : "Privatperson: Forlaget utbetaler til oppgitt bankkonto"}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </>
            <>{loadingStatus === "error" && <div>** Feil ved innlasting av kontraktene dine</div>}</>
        </>
    );
}
